import React from "react";
import { motion } from "framer-motion";
import { Lock, ShieldCheck, Globe, Server, Check } from "lucide-react";
import { fadeIn, fadeInUp, fadeInUpSmall } from "../../lib/animations";

const badges = [
  { id: "ssl", icon: Lock, title: "256-bit SSL", subtitle: "Encrypted" },
  { id: "soc2", icon: ShieldCheck, title: "SOC 2", subtitle: "Ready" },
  { id: "gdpr", icon: Globe, title: "GDPR", subtitle: "Compliant" },
  { id: "stripe", icon: Server, title: "Stripe", subtitle: "Secure Payments" },
];

const extras = ["PCI DSS Compliant", "TCPA Compliant Calls", "Data Never Sold"];

export function SecuritySection() {
  return (
    <section className="relative z-10 px-6 md:px-12 lg:px-24 py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        {/* Label */}
        <motion.div
          initial={fadeInUpSmall.initial}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.05 }}
          className="text-center mb-4"
        >
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-gray-400">
            Enterprise-Grade Security
          </span>
        </motion.div>

        {/* Heading */}
        <motion.div
          initial={fadeInUpSmall.initial}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.05 }}
          className="text-center mb-14"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Your Data is Protected</h2>
        </motion.div>

        {/* 4 Badge Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-12">
          {badges.map((badge, i) => (
            <motion.div
              key={badge.id}
              initial={fadeInUpSmall.initial}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.05 }}
              transition={{ delay: i * 0.08 }}
              className="bg-white rounded-2xl border border-gray-200 p-6 flex flex-col items-center text-center hover:shadow-md transition-shadow"
            >
              {/* Icon with glow bg */}
              <div className="relative w-14 h-14 flex items-center justify-center mb-4">
                <div className="absolute inset-0 rounded-full bg-[#39FF14]/10 blur-md" />
                <badge.icon className="w-7 h-7 text-[#39FF14] relative z-10" strokeWidth={1.8} />
              </div>
              <p className="font-bold text-gray-900 text-sm">{badge.title}</p>
              <p className="text-gray-500 text-xs mt-0.5">{badge.subtitle}</p>
            </motion.div>
          ))}
        </div>

        {/* Bottom extras */}
        <motion.div
          initial={fadeIn.initial}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.05 }}
          className="flex flex-wrap items-center justify-center gap-6"
        >
          {extras.map((text) => (
            <span key={text} className="flex items-center gap-1.5 text-sm text-gray-500">
              <Check className="w-4 h-4 text-[#39FF14]" />
              {text}
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
